import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import FormBuilder from './FormBuilder/FormBuilder';

const FormStructure = (props) => {
    const {
        schema,
        templateId,
        accessLevel,
        onSchemaChange,
        isFormArchived,
        isCommunication,
        formId,
        isWizardMode,
        componentToEditIndex,
        setComponentToEditIndex,
        onSchemaValidationChange,
        audience,
        recipientType,
        linkedToStudents,
    } = props;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden',
                }}
            >

                {schema && (
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minHeight: '100vh'
                        }}
                    >
                        <FormBuilder
                            schema={schema}
                            schemaId={templateId}
                            onSchemaChange={onSchemaChange}
                            onSchemaValidationChange={onSchemaValidationChange}
                            isFormArchived={isFormArchived}
                            isCommunication={isCommunication}
                            accessLevel={accessLevel}
                            formId={formId}
                            isWizardMode={isWizardMode}
                            componentToEditIndex={componentToEditIndex}
                            setComponentToEditIndex={setComponentToEditIndex}
                            audience={audience}
                            recipientType={recipientType}
                            linkedToStudents={linkedToStudents}
                        />
                    </Box>
                )}
            </Box>
        </>
    );
};

FormStructure.propTypes = {
    accessLevel: PropTypes.number,
    onNameChange: PropTypes.func,
    schema: PropTypes.array,
    formRef: PropTypes.object,
    name: PropTypes.string,
    templates: PropTypes.array,
    handleTemplateChange: PropTypes.func,
    onSchemaChange: PropTypes.func,
    templateId: PropTypes.number,
    editMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    expirationDate: PropTypes.string,
    remindInterval: PropTypes.number,
    onRemindIntervalChange: PropTypes.func,
    onExpirationDateChange: PropTypes.func,
    formId: PropTypes.number,
    formCategories: PropTypes.array,
    categories: PropTypes.array,
    onCategoriesChange: PropTypes.func,
    componentToEditIndex: PropTypes.number,
    setComponentToEditIndex: PropTypes.func,
    onSchemaValidationChange: PropTypes.func,
    isWizardMode: PropTypes.bool,
    audience: PropTypes.number,
    recipientType: PropTypes.string,
    linkedToStudents: PropTypes.bool,
    wizard: PropTypes.object,
    isCommunication: PropTypes.bool,
};

export default FormStructure;
